<template>
  <div>
    <el-checkbox v-model="registerSmsBrand">Register SMS Brand</el-checkbox>
    <div v-if="registerSmsBrand">
      <h2 class="form-section-header">SMS brand registration</h2>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-select
            v-model="form.organizationType"
            placeholder="Organization type"
          >
            <el-option
              v-for="type in organizationTypeOptions"
              :key="type.value"
              :label="type.label"
              :value="type.value"
            />
            <template slot="prefix">Organization type</template>
          </el-select>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-select
            v-model="form.vertical"
            placeholder="Brand vertical"
            filterable
          >
            <el-option
              v-for="{ label, value } in verticalOptions"
              :key="value"
              :label="label"
              :value="value"
            />
            <template slot="prefix">Brand vertical</template>
          </el-select>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input
            type="text"
            v-model="form.companyName"
            placeholder="Company name"
          >
            <template slot="prefix">Company name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-input type="text" v-model="form.ein" placeholder="EIN">
            <template slot="prefix">EIN</template>
          </el-input>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input type="text" v-model="form.street" placeholder="Street">
            <template slot="prefix">Street</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-input type="text" v-model="form.city" placeholder="City">
            <template slot="prefix">City</template>
          </el-input>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-select v-model="form.state" placeholder="Select State">
            <el-option
              v-for="state in stateOptions"
              :key="state.abbreviation"
              :label="state.name"
              :value="state.abbreviation"
            ></el-option>
            <template slot="prefix">State</template>
          </el-select>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-input
            type="text"
            v-model="form.postalCode"
            placeholder="Postal code"
          >
            <template slot="prefix">Postal code</template>
          </el-input>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input type="text" v-model="form.country" placeholder="Country">
            <template slot="prefix">Country</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-input type="text" v-model="form.email" placeholder="Email">
            <template slot="prefix">Email</template>
          </el-input>
        </el-col>
      </div>
      <div
        v-if="form.organizationType === 'PUBLIC_PROFIT'"
        class="inline-form-group"
      >
        <el-col :span="12">
          <el-input
            type="text"
            v-model="form.stockSymbol"
            placeholder="Stock symbol"
          >
            <template slot="prefix">Stock Symbol</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="11">
          <el-input
            type="text"
            v-model="form.stockExchange"
            placeholder="Stock exchange"
          >
            <template slot="prefix">Stock Exchange</template>
          </el-input>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-col :span="12">
          <el-input v-model="form.phone" placeholder="Phone">
            <template slot="prefix">Phone</template>
          </el-input>
        </el-col>
        <el-col :span="1"> </el-col>
        <el-col :span="11">
          <el-input v-model="website" placeholder="Website">
            <template slot="prefix">Website</template>
          </el-input>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SmsBrandingForm",

  props: {
    onSubmit: {
      type: Boolean,
      required: true,
    },
    clearForm: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      stateOptions: [
        { name: 'Alabama', abbreviation: 'AL' },
        { name: 'Alaska', abbreviation: 'AK' },
        { name: 'Arizona', abbreviation: 'AZ' },
        { name: 'Arkansas', abbreviation: 'AR' },
        { name: 'California', abbreviation: 'CA' },
        { name: 'Colorado', abbreviation: 'CO' },
        { name: 'Connecticut', abbreviation: 'CT' },
        { name: 'Delaware', abbreviation: 'DE' },
        { name: 'Florida', abbreviation: 'FL' },
        { name: 'Georgia', abbreviation: 'GA' },
        { name: 'Hawaii', abbreviation: 'HI' },
        { name: 'Idaho', abbreviation: 'ID' },
        { name: 'Illinois', abbreviation: 'IL' },
        { name: 'Indiana', abbreviation: 'IN' },
        { name: 'Iowa', abbreviation: 'IA' },
        { name: 'Kansas', abbreviation: 'KS' },
        { name: 'Kentucky', abbreviation: 'KY' },
        { name: 'Louisiana', abbreviation: 'LA' },
        { name: 'Maine', abbreviation: 'ME' },
        { name: 'Maryland', abbreviation: 'MD' },
        { name: 'Massachusetts', abbreviation: 'MA' },
        { name: 'Michigan', abbreviation: 'MI' },
        { name: 'Minnesota', abbreviation: 'MN' },
        { name: 'Mississippi', abbreviation: 'MS' },
        { name: 'Missouri', abbreviation: 'MO' },
        { name: 'Montana', abbreviation: 'MT' },
        { name: 'Nebraska', abbreviation: 'NE' },
        { name: 'Nevada', abbreviation: 'NV' },
        { name: 'New Hampshire', abbreviation: 'NH' },
        { name: 'New Jersey', abbreviation: 'NJ' },
        { name: 'New Mexico', abbreviation: 'NM' },
        { name: 'New York', abbreviation: 'NY' },
        { name: 'North Carolina', abbreviation: 'NC' },
        { name: 'North Dakota', abbreviation: 'ND' },
        { name: 'Ohio', abbreviation: 'OH' },
        { name: 'Oklahoma', abbreviation: 'OK' },
        { name: 'Oregon', abbreviation: 'OR' },
        { name: 'Pennsylvania', abbreviation: 'PA' },
        { name: 'Rhode Island', abbreviation: 'RI' },
        { name: 'South Carolina', abbreviation: 'SC' },
        { name: 'South Dakota', abbreviation: 'SD' },
        { name: 'Tennessee', abbreviation: 'TN' },
        { name: 'Texas', abbreviation: 'TX' },
        { name: 'Utah', abbreviation: 'UT' },
        { name: 'Vermont', abbreviation: 'VT' },
        { name: 'Virginia', abbreviation: 'VA' },
        { name: 'Washington', abbreviation: 'WA' },
        { name: 'West Virginia', abbreviation: 'WV' },
        { name: 'Wisconsin', abbreviation: 'WI' },
        { name: 'Wyoming', abbreviation: 'WY' }
      ],
      organizationTypeOptions: [
        {
          label: "Government",
          value: "GOVERNMENT",
        },
        {
          label: "Non profit",
          value: "NON_PROFIT",
        },
        {
          label: "Private Profit",
          value: "PRIVATE_PROFIT",
        },
        {
          label: "Public Profit",
          value: "PUBLIC_PROFIT",
        },
      ],
      verticalOptions: [
        {
          label: "Agriculture",
          value: "AGRICULTURE",
        },
        {
          label: "Communication",
          value: "COMMUNICATION",
        },
        {
          label: "Construction",
          value: "CONSTRUCTION",
        },
        {
          label: "Education",
          value: "EDUCATION",
        },
        {
          label: "Energy",
          value: "ENERGY",
        },
        {
          label: "Entertainment",
          value: "ENTERTAINMENT",
        },
        {
          label: "Financial",
          value: "FINANCIAL",
        },
        {
          label: "Gambling",
          value: "GAMBLING",
        },
        {
          label: "Government",
          value: "GOVERNMENT",
        },
        {
          label: "Healthcare",
          value: "HEALTHCARE",
        },
        {
          label: "Hospitality",
          value: "HOSPITALITY",
        },
        {
          label: "Human Resources",
          value: "HUMAN_RESOURCES",
        },
        {
          label: "Insurance",
          value: "INSURANCE",
        },
        {
          label: "Legal",
          value: "LEGAL",
        },
        {
          label: "Manufacturing",
          value: "MANUFACTURING",
        },
        {
          label: "Non Profit Organisation",
          value: "NGO",
        },
        {
          label: "Political",
          value: "POLITICAL",
        },
        {
          label: "Postal",
          value: "POSTAL",
        },
        {
          label: "Professional",
          value: "PROFESSIONAL",
        },
        {
          label: "Real Estate",
          value: "REAL_ESTATE",
        },
        {
          label: "Retail",
          value: "RETAIL",
        },
        {
          label: "Technology",
          value: "TECHNOLOGY",
        },
        {
          label: "Transportation",
          value: "TRANSPORTATION",
        },
      ],
      registerSmsBrand: false,
      website: "",
      form: {
        street: "",
        city: "",
        state: "",
        postalCode: "",
        country: "",
        companyName: "",
        phone: "",
        email: "",
        ein: "",
        stockSymbol: "", // v-if organization type = 'public profit'
        stockExchange: "", // v-if organization type = 'public profit'
        organizationType: "",
        vertical: "",
      },
    };
  },

  computed: {
    organizationType() {
      return this.form.organizationType;
    },
  },

  watch: {
    organizationType(val) {
      if (val !== "PUBLIC_PROFIT") {
        this.form.stockSymbol = "";
        this.form.stockExchange = "";
      }
    },

    onSubmit: {
      immediate: true,
      handler(val) {
        if (val) {
          const form = { ...this.form };
          const { organizationType } = form;

          if (organizationType !== "PUBLIC_PROFIT") {
            delete form.stockSymbol;
            delete form.stockExchange;
          }

          if (!this.registerSmsBrand) {
            return this.$emit("onSubmit", null);
          }

          if (this.website) {
            form.website = this.website;
          }

          this.$emit("onSubmit", form);
        }
      },
    },

    clearForm: {
      immediate: true,
      handler(val) {
        if (val) {
          this.clearFields();
        }
      },
    },
  },

  methods: {
    clearFields() {
      this.website = "";
      this.registerSmsBrand = false;
      for (let key of Object.keys(this.form)) {
        this.form[key] = "";
      }
    },
  },
};
</script>

<style scoped>
.el-checkbox {
  margin-left: 0;
}
</style>
